import React from 'react'
import { connect } from 'react-redux'
import { signOut } from '../../store/actions/authActions'
import { Nav, Dropdown } from 'react-bootstrap'
import { myFirestore } from '../../services/firebase'
import {withRouter} from 'react-router-dom'
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <Nav.Link

    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >


    {children}
  </Nav.Link>
));
const SignedInLinks = (props) => {
  
  function gotonpeerchat()
  {
    props.history.push('/peerchat')
    
  }
  function startCounseling() {
    
    
    myFirestore.collection('users')
      .doc(props.auth.uid)
      .set({
        isAvailable: true,
        nowCounseling: '',
      },
        { merge: true })
      .then(() => {

        gotonpeerchat();

        
      })
      .catch(err => {


      })
    
  }
  console.log(props);
  return (
    <div>
      <Nav>
        

        <Dropdown alignRight>
          <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">


            <div className="avatar">
              <div className='initials'>{props.profile.username && props.profile.username.substring(0, 1).toUpperCase()}
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Header>{props.profile.username}</Dropdown.Header>
            <Dropdown.Item href='/profile'>Profile</Dropdown.Item>
            {props.profile.isCounselor ?
              <Dropdown.Item  onClick={startCounseling}>Start Counseling</Dropdown.Item>
          

            : null}
            
            <Dropdown.Item onClick={props.signOut}>Sign Out</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Nav>

    </div>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut())
  }
}

export default connect(null, mapDispatchToProps)(withRouter(SignedInLinks))
